import { getMetricsByDeployId } from "@/lib/metric/api";
import { Metric } from "@/types";
import { useQuery } from "@tanstack/react-query";

export function useGetMetrics(
  deployId: string,
  startTime: Date,
  endTime: Date,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ["metrics", deployId, startTime, endTime],
    queryFn: () =>
      getMetricsByDeployId(deployId, startTime.getTime(), endTime.getTime()),
    select: (data) => data.data.items as Metric[],
    enabled,
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
}
